import { type FC } from 'react';
import {
  MessageProvider,
  QuotedMessage,
  useChatContext,
  useMessageContext,
} from 'stream-chat-react';
import { pickMessageRenderer } from '../pick-message-renderer';

/**
 * Renders the quoted block inside a message with the renderer that suits the
 * *quoted* message's author, not the author of the message doing the quoting.
 *
 * Stream's `QuotedMessage` reads `renderText` off the message context, which
 * carries the outer message's renderer, so a psychologist quoting a client
 * would otherwise show the client's prose parsed as markdown — the same defect
 * as in the bubble itself, one level in (IP-2192).
 */
export const CustomQuotedMessage: FC = () => {
  const messageContext = useMessageContext('CustomQuotedMessage');
  const { client } = useChatContext('CustomQuotedMessage');
  const renderText = pickMessageRenderer(messageContext.message.quoted_message?.user ?? undefined, client.userID);

  return (
    <MessageProvider value={{ ...messageContext, renderText }}>
      <QuotedMessage />
    </MessageProvider>
  );
};
